import { connect, Component, Rendering } from "macguffin"
import GameMode from "game/modes"
import GameModeGroup from "game/modes/GameModeGroup"

import EarthBackground from "./states/earth"
import MarsBackground from "./states/mars"

import BackgroundImage from "utils/BackgroundImage"

const firstAnimation = "firstBackgroundAnimation 5s cubic-bezier(0.950, 0.050, 0.795, 0.035) 1.5s forwards"
const secondAnimation = "secondBackgroundAnimation 5s forwards"

const spaceGroup = new GameModeGroup([GameMode.FREESPIN, GameMode.MARS_INTRO])

const earthSkyStyle = {
    backgroundRepeat: "repeat-x",
    backgroundSize: "100% 100%"
}

@connect(state => ({
    currentSpinData: state.game.currentSpinData,
    currentPickStageIndex: state.game.currentPickStageIndex,
    currentGameMode: state.game.currentGameMode,
    isSpinning: state.game.isSpinning,
    globalPaused: state.base.paused
}), {})
export default class Background extends Component {

    componentWillMount() {
        if (this.props.currentGameMode === GameMode.PICK && this.props.currentPickStageIndex) {
            this.setState({
                backgroundStyle: { transform: `translateY(200%)` }
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        const currentProps = this.props

        if (nextProps.currentGameMode !== currentProps.currentGameMode) {
            switch(nextProps.currentGameMode) {
                case GameMode.BONUS_INTRO:
                    this.setState({
                        backgroundStyle: { animation: firstAnimation }
                    })
                    break
                case GameMode.PICK:
                    if (currentProps.currentGameMode === GameMode.RESUME && nextProps.currentPickStageIndex) {
                        this.setState({
                            backgroundStyle: { transform: `translateY(200%)` }
                        })
                    }
                    break
                case GameMode.FREESPIN:
                    if (!this.state || this.state.backgroundStyle.animation === firstAnimation) {
                        this.setState({
                            backgroundStyle: { animation: secondAnimation }
                        })
                    }
                    break
                case GameMode.MARS_INTRO:
                    this.setState({
                            backgroundStyle: { transform: `translateY(200%)` }
                        })
                    break
                case GameMode.MAIN:
                    this.setState({
                        backgroundStyle: { transform: `translateY(0)` }
                    })
                    break
            }
        }

        if (nextProps.isSpinning !== currentProps.isSpinning) {
            const { endStickyWilds } = nextProps.currentSpinData
            const filter = (endStickyWilds && endStickyWilds.length) ? "brightness(50%)" : "none"
            this.setState({ filter })
        }
    }

    render() {
        const { props, state } = this
        const { backgroundStyle, filter } = state || {}
        const { currentPickStageIndex, currentGameMode } = props

        const showEarth = (isNaN(currentPickStageIndex) || currentPickStageIndex < 1)
        const showSpace = spaceGroup.contains(currentGameMode) || currentPickStageIndex > 0

        const combinedStyle = {
            ...backgroundStyle,
            ...earthSkyStyle
        }

        return <div key="backgroundContainer" id="backgroundContainer" style={{filter}}>
            <BackgroundImage className="backgroundColourContainer" assetName="earthSky" style={combinedStyle} />
            {showEarth && <EarthBackground {...props}/>}
            {showSpace && <MarsBackground {...props}/>}
        </div>
    }
}
